import { DEVICE_ID_V2, SIGNATURE_TOKEN } from '@weee-fe/core';

import { getCookie, setCookie } from './cookie';

export const updateFinger = async (): Promise<any> => {
  if (window.raptor) {
    window.raptor.reportLogs({
      event: 'updateFinger_before',
      data: {
        ua: window.navigator.userAgent,
        __d2__: getCookie(DEVICE_ID_V2),
        __st__: getCookie(SIGNATURE_TOKEN),
        traceId: window.sessionStorage.getItem('tempTraceId') || ''
      }
    });
  }

  try {
    const { Fingerprint } = await import('@weee-fe/core');
    const finger = new Fingerprint();
    let data = finger.getData();
    if (!data[DEVICE_ID_V2]) {
      data = await finger.getDataDirectly();
    }
    if (window.raptor) {
      window.raptor.reportLogs({
        event: 'updateFinger_after',
        data: {
          ua: window.navigator.userAgent,
          __d2__: data[DEVICE_ID_V2],
          __st__: data[SIGNATURE_TOKEN],
          traceId: window.sessionStorage.getItem('tempTraceId') || ''
        }
      });
    }
    if (data[DEVICE_ID_V2]) {
      setCookie(DEVICE_ID_V2, data[DEVICE_ID_V2]);
    }
    if (data[SIGNATURE_TOKEN]) {
      setCookie(SIGNATURE_TOKEN, data[SIGNATURE_TOKEN]);
    }
    return data;
  } catch (error) {
    if (window.raptor) {
      window.raptor.reportLogs({
        event: 'updateFinger_error',
        data: {
          error,
          ua: window.navigator.userAgent
        }
      });
    }
    return {};
  }
};
